export default __webpack_public_path__ + "f56f8192aedcddad042442590a28ce09.png";